// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__nDRyF","content":"Grid_content__ONh1K"};